import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  Item,
  ItemActionResult,
  ItemView,
  ItemViewProviderDirective
} from '@ntap/core';
import { PrimeNGButtonSaveCloseItemActionComponent } from '@ntap/primeng';
import { Observable, Subject, switchMap } from 'rxjs';

@Component({
  selector: 'app-deny-mjesto-deduplication',
  templateUrl: './deny-mjesto-deduplication.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DenyMjestoDeduplicationComponent
  extends PrimeNGButtonSaveCloseItemActionComponent
  implements OnInit
{
  override itemViewProvider: ItemViewProviderDirective<ItemView> = inject(
    ItemViewProviderDirective
  );
  formBuilder: FormBuilder = inject(FormBuilder);
  razlogFg: FormGroup;
  submitSubject = new Subject<boolean>();
  showDialog = false;

  ngOnInit(): void {
    this.razlogFg = this.formBuilder.group({
      razlog: ['', Validators.required]
    });
  }

  confirmRejection() {
    this.showDialog = false;
    this.submitSubject.next(true);
  }

  override executeAction(event: any): void {
    this.showDialog = true;
    super.executeAction(event);
  }

  protected override doExecuteWithItem(
    item: Item
  ): Observable<ItemActionResult> {
    return this.submitSubject.pipe(
      switchMap(() => {
        const razlog = this.razlogFg.get('razlog');
        const itemWithReason = Object.assign({}, item, {
          $reason: razlog?.value || null
        });
        return super.doExecuteWithItem(itemWithReason);
      })
    );
  }

  closeDialog() {
    this.showDialog = false;
  }
}
